import { render, staticRenderFns } from "./smsValid.vue?vue&type=template&id=f997f6f2&scoped=true"
import script from "./smsValid.vue?vue&type=script&lang=js"
export * from "./smsValid.vue?vue&type=script&lang=js"
import style0 from "./smsValid.vue?vue&type=style&index=0&id=f997f6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f997f6f2",
  null
  
)

export default component.exports